(function() {
  'use strict';

  let error;
  let form_lanuage = 'en';
  let multiFields = new Array();
  let dateFields = new Array();

  multiFields["interest[]"] = "interest"
  multiFields["optin"] = "optin"
  let arr_interest = new Array();

  function onbeforesubmit() {
    return true;
  }

  // Function to toggle button state based on validation
  function toggleButtonState(isValid) {
    const button = document.querySelector('.js-footer__signup-button');
    if (button) {
      button.disabled = !isValid;
      if (isValid) {
        button.classList.remove('disabled');
      } else {
        button.classList.add('disabled');
      }
    }
  }

  function CheckInputs(){
    const newsletterField = document.querySelector('.js-newsletter_field');
    const dataNewsletterEmpty = newsletterField.getAttribute('data-newsletter-empty');
    const dataNewsletterEmailError = newsletterField.getAttribute('data-newsletter-email-error');
    const emailField = document.querySelector('.js-emarsys-newsletter-input');
    const errorMessage = document.querySelector('.js-newsletter-error-message');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let email = emailField.value;

    // Reset error message
    errorMessage.style.display = 'none';
    errorMessage.innerText = '';
    newsletterField.classList.remove('newsletter_field--error');
    newsletterField.classList.remove('newsletter_field--valid');

    if (email === '') {
      newsletterField.classList.add('newsletter_field--error');
      errorMessage.style.display = 'block';
      errorMessage.innerText = dataNewsletterEmpty;
      toggleButtonState(false); // Disable button
      return false;
    } else if (!emailPattern.test(email)) {
      newsletterField.classList.add('newsletter_field--error');
      errorMessage.style.display = 'block';
      errorMessage.innerText = dataNewsletterEmailError;
      toggleButtonState(false); // Disable button
      return false;
    }

    // If validation passes, submit the form
    newsletterField.classList.remove('newsletter_field--error');
    newsletterField.classList.add('newsletter_field--valid');
    toggleButtonState(true); // Enable button

    return true;
  }

  function validateEmailField() {
    setTimeout(CheckInputs, 500); // Delay validation by 500 milliseconds
  }

  function SubmitIt(){
    if(window.onbeforesubmit) {
      onbeforesubmit();
    }
    document.ProfileForm.submit();
  }

  document.querySelector('.js-emarsys-newsletter-input').addEventListener('input', validateEmailField);
  document.querySelector('.js-footer__signup-button').addEventListener('click', function() {
    if (CheckInputs()) {
      SubmitIt();
    }
  });
  
  // Function to extract query parameters from the URL
  function getQueryParameter(param) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    return params.get(param);
  }

  // Store the 'result' query parameter in a variable
  const resultParam = getQueryParameter('result');

  function createSuccessContent() {
    const successMessage = document.querySelector('.js-emarsys-newsletter-success');
    if (successMessage) {
      const heading = successMessage.getAttribute('data-success-message-heading');
      const text = successMessage.getAttribute('data-success-message-text');
      const logo = successMessage.getAttribute('data-logo');
      const closeText = successMessage.getAttribute('data-close-text');
      const closeIcon = successMessage.getAttribute('data-close-icon');
      
      successMessage.innerHTML = `
        <div class="emarsys-newsletter-success__pop-up">
          <h2 id="dialog_label" class="emarsys-newsletter-success__title">${heading}</h2>
          <div id="dialog_desc" class="emarsys-newsletter-success__text">${text}</div>
          <div class="emarsys-newsletter-success__logo" aria-hidden="true">
            <span>${logo}</span>
          </div>
          <button type="button"
            class="emarsys-newsletter-success__close js-emarsys-newsletter-success-close modal__close-button link link--text focus-inset"
            aria-label="${closeText}">
            <span class="svg-wrapper">${closeIcon}</span>
          </button>
        </div>
      `;

      successMessage.classList.add('emarsys-newsletter-success--visible');
      successMessage.setAttribute('aria-hidden', 'false');
      setTimeout( () => {
        successMessage.focus();
      }, 3000)
    }
  }

  // Function to check the result parameter and perform actions based on its value
  function checkResult() {
    const successMessage = document.querySelector('.js-emarsys-newsletter-success');

    if (resultParam === 'success') {
      successMessage.classList.add('emarsys-newsletter-success--visible');
      createSuccessContent();
    }
  }

  function closeModal() {
    const successMessage = document.querySelector('.js-emarsys-newsletter-success');

    if (successMessage.innerHTML !== '') {
      successMessage.classList.remove('emarsys-newsletter-success--visible');
      successMessage.setAttribute('aria-hidden', 'true');
    }
  }

  function closeModalButtonHandler() {
    const closeBtn = document.querySelector('.js-emarsys-newsletter-success-close');

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeModal();
      });
    }
  }
    // Event listener for DOMContentLoaded to ensure the DOM is fully loaded before running the script
  document.addEventListener('DOMContentLoaded', function() {
    checkResult();
    closeModalButtonHandler();

    // Initialize button state (disabled by default)
    toggleButtonState(false);
    
    setTimeout( () => {
      closeModal();
    }, 15000);
  });

})();
